/**
 * 共享格式化工具 - 抽自 ChatHome / AppSidebar, 避免重复实现.
 */

/** 取名字首字符作头像占位 (中文取首个字, 英文取首字母). */
export function avatarText(name: string): string {
  return Array.from(name)[0] || '?'
}

/** ISO 时间 -> 友好相对时间 (刚刚 / N分钟前 / 昨天 / M月D日). 空或非法返回空串. */
export function formatRelativeTime(iso: string | null): string {
  if (!iso) return ''
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return ''
  const diff = Date.now() - d.getTime()
  const min = Math.floor(diff / 60000)
  if (min < 1) return '刚刚'
  if (min < 60) return `${min}分钟前`
  const hour = Math.floor(min / 60)
  if (hour < 24) return `${hour}小时前`
  const day = Math.floor(hour / 24)
  if (day === 1) return '昨天'
  if (day < 7) return `${day}天前`
  return `${d.getMonth() + 1}月${d.getDate()}日`
}
